import React from 'react';
import loadingLogo from '../../img/Peiix_isotipo_color.png';
import '../../Styles/SpinnerOverlay.css';

import { ProgressBar } from 'react-bootstrap';

/**
 * Componente de carga universal para la aplicación.
 * Utiliza el isotipo de Peiix con una animación de color gradual.
 * 
 * @param {boolean} show - Controla la visibilidad del overlay.
 * @param {string} message - Mensaje a mostrar debajo del logo.
 * @param {number} progress - (Opcional) Progreso numérico para mostrar una barra.
 */
const LoadingOverlay = ({ show, message = "Cargando...", progress = null }) => {
    if (!show) return null;

    return (
        <div className="spinner-overlay">
            <div className="loading-logo-container">
                <div 
                    className="loading-logo grayscale" 
                    style={{ backgroundImage: `url(${loadingLogo})` }}
                ></div>
                <div 
                    className="loading-logo color" 
                    style={{ backgroundImage: `url(${loadingLogo})` }}
                ></div>
            </div>
            <div style={{ 
                marginTop: '20px', 
                color: '#3E4144', 
                fontSize: '16px', 
                fontWeight: 'bold',
                fontFamily: 'Montserrat, sans-serif'
            }}>
                {message}
            </div>
            {progress !== null && (
                <div style={{ width: '80%', maxWidth: '400px', marginTop: '20px' }}>
                    <ProgressBar 
                        animated 
                        now={progress} 
                        label={`${Math.round(progress)}%`} 
                        variant="success"
                    />
                </div>
            )}
        </div>
    );
};

export default LoadingOverlay;
